import { useContext } from 'react';
import UserViewContextContext from '../UserViewContextContext';
import type { UserViewContextProviderValue } from '../types';

const useUserViewContext = (): UserViewContextProviderValue => {
    const context = useContext(UserViewContextContext);

    if (context === null) {
        throw new Error('useUserViewContext must be used within UserViewContextProvider');
    }

    return context;
};

export default useUserViewContext;
